import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

export const IceBlue = (props: SvgIconT.Props) => (
  <SvgIcon width={24} height={24} {...props} viewBox="0 0 24 24">
    <path
      fill="#8DC7E9"
      d="M0 0v24h24V0H0Zm19.128 10.128-5.4 8.328-4.536-3.024-3.552 5.232-3.576-2.424 5.952-8.76 4.464 2.952 3.024-4.68-2.592-1.68 7.248-1.536 1.536 7.248-2.592-1.68.024.024Z"
    />
  </SvgIcon>
);

export default IceBlue;
